import React from 'react';
import { useParams } from 'react-router-dom';

import { FicheDescriptiveDisplay } from 'components/FicheDescriptiveDisplay/FicheDescriptiveDisplay';
import Spinner from 'components/WrappedComponents/Spinner';
import { DossierProvider } from 'hooks/dossiers/DossierContext';
import { useFetchDossier } from 'hooks/dossiers/useFetchDossier';
import { PageDossierParam } from 'types/pageDossier';

import ActionSuiviVehicule from './Actions/ActionsSuiviVehicule';

const Details: React.FC = () => {
  const { id } = useParams<PageDossierParam>();

  if (id === undefined || id === null) {
    throw new Error("L'Id du dossier devrait être défini");
  }

  const [dossier, setDossier] = useFetchDossier(id);

  if (dossier === null) {
    return <Spinner />;
  }

  return (
    <DossierProvider
      value={{
        dossier: { result: dossier, setDossier: setDossier },
      }}
    >
      <FicheDescriptiveDisplay>
        <ActionSuiviVehicule />
      </FicheDescriptiveDisplay>
    </DossierProvider>
  );
};

export default Details;
